const filterForm = document.querySelector('#filterSidebar');

filterForm.querySelectorAll('input').forEach((input) => {
    console.log(input);
    if (input.hasAttribute('silent')){
        return ;
    }


    input.addEventListener('change', (e) => {
        document.getElementById('result_loader').classList.toggle('visually-hidden')
        // filterForm.submit()
        input.closest('form').submit();
    })
})

